import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=66c2c9ce&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=66c2c9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2c9ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c2c9ce')) {
      api.createRecord('66c2c9ce', component.options)
    } else {
      api.reload('66c2c9ce', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=66c2c9ce&scoped=true&", function () {
      api.rerender('66c2c9ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YBRTxCw5rpGm/JS/comp/DocBox.vue"
export default component.exports